import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import ReactPlayer from "react-player";
import { url } from "inspector";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: "0 0 20px 0",
    },
    center: { textAlign: "center" },
    test: { margin: "0 auto" },
  })
);

export default function Header() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.center}>
        <img src="nephro-logo-transparent.png" alt="logo" width="140px" />
        <Typography variant="body1">وبینار های برگزار شده</Typography>
      </div>
    </div>
  );
}
